var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3119_5606",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3119_5606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 14.6666C10.2364 14.6666 10.4344 14.5868 10.5941 14.427C10.7538 14.2673 10.8337 14.0694 10.8337 13.8333V10.5C10.8337 10.2638 10.7538 10.0659 10.5941 9.90621C10.4344 9.74649 10.2364 9.66663 10.0003 9.66663C9.76421 9.66663 9.5663 9.74649 9.40658 9.90621C9.24685 10.0659 9.16699 10.2638 9.16699 10.5V13.8333C9.16699 14.0694 9.24685 14.2673 9.40658 14.427C9.5663 14.5868 9.76421 14.6666 10.0003 14.6666ZM10.0003 7.99996C10.2364 7.99996 10.4344 7.9201 10.5941 7.76038C10.7538 7.60065 10.8337 7.40274 10.8337 7.16663C10.8337 6.93051 10.7538 6.7326 10.5941 6.57288C10.4344 6.41315 10.2364 6.33329 10.0003 6.33329C9.76421 6.33329 9.5663 6.41315 9.40658 6.57288C9.24685 6.7326 9.16699 6.93051 9.16699 7.16663C9.16699 7.40274 9.24685 7.60065 9.40658 7.76038C9.5663 7.9201 9.76421 7.99996 10.0003 7.99996ZM10.0003 18.8333C8.84755 18.8333 7.76421 18.6145 6.75033 18.177C5.73644 17.7395 4.85449 17.1458 4.10449 16.3958C3.35449 15.6458 2.76074 14.7638 2.32324 13.75C1.88574 12.7361 1.66699 11.6527 1.66699 10.5C1.66699 9.34718 1.88574 8.26385 2.32324 7.24996C2.76074 6.23607 3.35449 5.35413 4.10449 4.60413C4.85449 3.85413 5.73644 3.26038 6.75033 2.82288C7.76421 2.38538 8.84755 2.16663 10.0003 2.16663C11.1531 2.16663 12.2364 2.38538 13.2503 2.82288C14.2642 3.26038 15.1462 3.85413 15.8962 4.60413C16.6462 5.35413 17.2399 6.23607 17.6774 7.24996C18.1149 8.26385 18.3337 9.34718 18.3337 10.5C18.3337 11.6527 18.1149 12.7361 17.6774 13.75C17.2399 14.7638 16.6462 15.6458 15.8962 16.3958C15.1462 17.1458 14.2642 17.7395 13.2503 18.177C12.2364 18.6145 11.1531 18.8333 10.0003 18.8333Z",
    fill: "#EAD40C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.6ba7a354538f73eb7478bc792a42536f.svg";
export { ForwardRef as ReactComponent };